import React, {Component} from "react";
import './index.css'
import Modal, {ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import PropTypes from 'prop-types'

class ModalTutorial extends Component {
    constructor(props) {
        super(props);

        this.state = {
            colors: ['#e76f51', '#f4a261', '#e9c46a', '#2a9d8f', '#264653', '#3d5a80', '#98c1d9']
        };

        this.ref = {
            modal: React.createRef(),
            close: React.createRef()
        };
    }

    static defaultProps = {
        onClose: _ => null
    };

    static propTypes = {
        onClose: PropTypes.func
    };

    componentDidMount() {
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return false;
    }

    render() {
        return <Modal ref={this.ref.modal}
                      name={'ModalTutorial'}
                      size={'large'}
                      title={'فایل‌های آموزشی'}>
            <ModalContent>
                <div className={'dis-f'}>
                    {window.ENV?.MULTIMEDIA?.map((item, index) => {
                        return <div key={index} className={'link fb-5'}>
                            <div className={'mar-8'} onClick={this.tutorialClickHandler.bind(this, item)}>{item.title}</div>
                        </div>;
                    })}
                    {/*<iframe style={{width: '100%', minHeight: 500}} src={'https://www.aparat.com/video/video/embed/videohash/OJued/vt/frame?isamp'} title={'ویدیو آموزش استفاده از سامانه'}></iframe>*/}
                </div>
            </ModalContent>
            <ModalControls>
                <Button refer={this.ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
            </ModalControls>
        </Modal>;
    }

    close(success) {
        this.ref.modal.current.close();

        if (success === true || this.state.updated)
            this.props.onSuccess();

        this.props.onClose();
    }

    open(data) {
        this.setState({
            data
        });

        return this.ref.modal.current.open();
    }

    tutorialClickHandler(item) {
        const win = window.open('', item.title);
        win.document.body.innerHTML = `<title>${item.title}</title><style>body{margin: 0}</style><object style="width: 100%; height: 100vh" data="${item.url}" title="${item.title}"></object>`;
    }
}

export default (ModalTutorial)